module.exports = __webpack_public_path__ + "d3a8689930e65cbe016009d7553a0780.svg";